var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 86,
    viewBox: "0 0 96 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5 32.2H19.6V24H0.199997V71.8H30.5V32.2ZM11.7 64.3H8V60.6H11.7V64.3ZM11.7 57H8V53.3H11.7V57ZM11.7 49.6H8V45.9H11.7V49.6ZM11.7 42.4H8V38.7H11.7V42.4ZM11.7 35H8V31.3H11.7V35ZM25.4 65.2H21.7V61.5H25.4V65.2ZM25.4 58H21.7V54.3H25.4V58ZM25.4 50.6H21.7V46.9H25.4V50.6ZM25.4 43.3H21.7V39.6H25.4V43.3Z",
    fill: "#989898"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4 25.3999V11.3999H25.3V74.5999H95.5V25.3999H60.4ZM39.4 67.5999H32.4V60.5999H39.4V67.5999ZM39.4 53.4999H32.4V46.4999H39.4V53.4999ZM39.4 39.4999H32.4V32.4999H39.4V39.4999ZM39.4 25.3999H32.4V18.3999H39.4V25.3999ZM53.4 67.5999H46.4V60.5999H53.4V67.5999ZM53.4 53.4999H46.4V46.4999H53.4V53.4999ZM53.4 39.4999H46.4V32.4999H53.4V39.4999ZM53.4 25.3999H46.4V18.3999H53.4V25.3999ZM88.5 67.5999H60.4V60.5999H67.4V53.5999H60.4V46.5999H67.4V39.5999H60.4V32.5999H88.5V67.5999ZM81.5 39.4999H74.5V46.4999H81.5V39.4999ZM81.5 53.4999H74.5V67.4999H81.5V53.4999Z",
    fill: "#82AA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95.7,
    height: 86,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.c9202b55440154e741ac759b2fcce008.svg";
export { ForwardRef as ReactComponent };